import { GanttChart } from "./gantt-chart";

export { GanttChart };
